import { useQuery } from 'react-query';
import { getScreeningStatus } from 'services/screening';
import useUserProfileQuery from 'hooks/queries/useUserProfileQuery';
import useAbortController from 'hooks/useAbortController';

const useScreeningStatusQuery = ({ options }) => {
  const { data: { applicationId } = {} } = useUserProfileQuery();
  const abortControllerOptions = useAbortController();

  return useQuery(
    ['getScreeningStatus', applicationId],
    async () => {
      const response = await getScreeningStatus({
        applicationId,
        options: abortControllerOptions,
      });

      return response?.status?.resultMessage ?? null;
    },
    {
      ...options,
      enabled: Boolean(applicationId?.length && options.enabled),
    },
  );
};

export default useScreeningStatusQuery;
